import { jsx as _jsx } from "react/jsx-runtime";
import { Size } from '@jetbrains/ring-ui/components/input/input';
import { useFormContext } from 'react-hook-form';
import RegisteredInput from '@app/common/hook-form/registered-input';
function PluginIdField({ settingIndex }) {
    const { control } = useFormContext();
    return (_jsx(RegisteredInput, { label: "Plugin ID", size: Size.L, name: `content.${settingIndex}.pluginId`, control: control, autoComplete: "off" }));
}
export default PluginIdField;
